import { useState } from 'react'

import { Box, Button, CollapsableCard, Icon, Text } from '@factorialco/deprecated-design-system'
import {
  A3innuvaCompaniesLegalEntitiesFragment,
  A3innuvaCompensationCodeFragment,
  PayrollConceptOptionFragment,
} from 'generated/resources/graphql'

import { CompensationByLegalEntityFiller } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/CodeFillers/CompensationByLegalEntityFiller'
import { compensationsToOptions } from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'
import {
  A3InnuvaMapping,
  A3InnuvaWizardData,
} from 'modules/payroll_integrations_a3innuva/lib/types'

interface Props {
  data: A3InnuvaWizardData
  onMappingChanged: (mappings: A3InnuvaMapping[]) => void
  a3innuvaCompensations: A3innuvaCompensationCodeFragment[]
  legalEntities: A3innuvaCompaniesLegalEntitiesFragment[]
  payrollConcepts: PayrollConceptOptionFragment[]
}

export const CompensationByLegalEntity = ({
  data,
  onMappingChanged,
  a3innuvaCompensations,
  legalEntities,
  payrollConcepts,
}: Props) => {
  const filteredLegalEntities = legalEntities.filter((legalEntity) => {
    return data.answers[`legal_entity_${legalEntity.id}`]
  })

  const buildA3innuvaCompensationsByLegalEntity = () => {
    const result: Record<string, A3innuvaCompensationCodeFragment[]> = {}

    a3innuvaCompensations.forEach((a3innuvaCompensation) => {
      const existingArray = result[a3innuvaCompensation.companyCode]
      if (Array.isArray(existingArray)) {
        existingArray.push(a3innuvaCompensation)
      } else {
        result[a3innuvaCompensation.companyCode] = [a3innuvaCompensation]
      }
    })
    return result
  }

  const a3innuvaCompensationsByLegalEntityCode = buildA3innuvaCompensationsByLegalEntity()

  const defaultCardsState = () => {
    const defaultStates: Record<string, boolean> = {}

    filteredLegalEntities.forEach((legalEntity) => {
      defaultStates[legalEntity.id] = true
    })

    return defaultStates
  }

  const [openStates, setOpenStates] = useState<Record<string, boolean>>(defaultCardsState())

  const toggleCard = (id: string) => {
    setOpenStates((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const a3innuvaCompensationsBylegalEntityCode = (id: number) => {
    const legalEntityCode = data.answers[`legal_entity_${id}`] ?? ''
    return a3innuvaCompensationsByLegalEntityCode[legalEntityCode] ?? []
  }

  return (
    <>
      {filteredLegalEntities.map((legalEntity) => {
        return (
          <Box justifyContent="spaceBetween" key={legalEntity.id} flexDirection="column" gap="s32">
            <Box background="grey200" borderRadius={{ all: 'abs008' }}>
              <CollapsableCard
                open={openStates[legalEntity.id] ?? false}
                contentBackground="grey000White"
                contentPadding="s0"
                Card={
                  <Box flexDirection="row" justifyContent="spaceBetween">
                    <Box flexDirection="row" gap="s8" alignItems="center">
                      <Icon.Large icon="building" />
                      <Text.Header3>{legalEntity.legalName}</Text.Header3>
                    </Box>
                    <Button
                      iconName={openStates[legalEntity.id] ? 'chevron-up' : 'chevron-down'}
                      onClick={() => toggleCard(legalEntity.id.toString())}
                      type="secondary"
                    />
                  </Box>
                }
                Content={
                  <CompensationByLegalEntityFiller
                    data={data}
                    onMappingChanged={onMappingChanged}
                    options={compensationsToOptions(
                      a3innuvaCompensationsBylegalEntityCode(legalEntity.id)
                    )}
                    payrollConcepts={payrollConcepts}
                    legalEntityId={legalEntity.id.toString()}
                  />
                }
              />
            </Box>
          </Box>
        )
      })}
    </>
  )
}
